<div class="report-content">
    <div style="display: flex; justify-content: space-between;">
        <h2>{{graph.label}}</h2>
        <span>{{graph.unit}}</span>
    </div>
    <mat-form-field *ngIf="!isEmpty && graph.display==='multi'">
        <mat-select [(value)]="graph.mode">
            <mat-option value="doughnut"      >{{'monitoring.graphs.doughnut.shortLabel'      | translate}}</mat-option>
            <mat-option value="bar-vertical"  >{{'monitoring.graphs.barVertical.shortLabel'   | translate}}</mat-option>
            <mat-option value="pie"           >{{'monitoring.graphs.pie.shortLabel'           | translate}}</mat-option>
            <mat-option value="bar-horizontal">{{'monitoring.graphs.barHorizontal.shortLabel' | translate}}</mat-option>
            <mat-option value="radar"         >{{'monitoring.graphs.radar.shortLabel'         | translate}}</mat-option>
            <mat-option value="table"         >{{'monitoring.graphs.table.shortLabel'         | translate}}</mat-option>
        </mat-select>
    </mat-form-field>
    <ng-container>
        <div *ngIf="isEmpty">{{'monitoring.graphs.noData.fullLabel' | translate}}</div>
        <app-monitoring-graph-modal *ngIf="!isEmpty" [graph]="graph"></app-monitoring-graph-modal>
    </ng-container>
</div>
